import { h32, h64 } from 'xxhashjs'
import { sortObjectKeys } from './object'
import { blake2bHex } from 'blakejs'

/**
 * Isomorphic hash function.
 */
export const hash = (input: string) => {
  return h32(input, 0xfff).toString(16)
}

export const hashNeue = (input: string) => {
  return h64(input, 0xf1db239a2).toString(16)
}

export const hashJson = (input: Parameters<typeof JSON.stringify>[0]) => {
  const sorted = sortObjectKeys(input)
  return hash(JSON.stringify(sorted))
}

export const hashRepoId = (repoId: string) => blake2bHex(repoId).slice(0, 8)
